import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';
import { InitService } from './services/init.service';

import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { events } from 'aws-amplify/data';
import { environment } from 'src/environments/environment';
import * as data from './helpers/menu.json';
import { CognitoService } from './services/cognito.service';
import { NotificationsService } from './services/notifications/notifications.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Explorandes - Operations';
  @ViewChild('menuTrigger') trigger: any;
  showFiller = false;
  @ViewChild('drawer') snav: any;
  mobileQuery: MediaQueryList;
  isExpanded: boolean = true;
  matchesTemp: boolean = true;
  tab: string = 'noRead';
  imgLogo = 'assets/brand/explo-horizontal-blanco.svg';
  menuData: any = (data as any).default;

  private estadoLayoutSubscription: Subscription | undefined;
  public isDrawerVisible = false;

  estadoInit: boolean = false;

  appBranch: string = environment.appEnv;

  sourcingTarifa: string = `${environment.sourcingTarifario}`;
  notificationsSubscription: any;

  listaNotificaciones: any[] = [];
  notificacionesLeidas: any[] = [];
  notificacionesNoLeidas: any[] = [];

  isTokenReady = false;

  closeMenu() {
    this.trigger.closeMenu();
  }
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private serviceInit: InitService,
    private router: Router,
    private cognitoService: CognitoService,
    private notificationsService: NotificationsService
  ) {
    this.estadoLayoutSubscription =
      this.serviceInit.currentEstadoLayout.subscribe((e) => {
        this.estadoInit = e;
        if (!this.estadoInit) {
          this.matchesTemp = false;
        } else this.matchesTemp = true;
      });
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);
    if (this.mobileQuery.matches) {
      this.matchesTemp = false;
    }
  }

  private _mobileQueryListener: () => void;
  async ngOnInit() {
    try {
      const hasValidSession = await this.cognitoService.isAuthenticated();

      if (hasValidSession) {
        this.isTokenReady = true;
        this.handleAuthenticatedUser();
      } else {
        this.isTokenReady = false;
        this.serviceInit.setEstadoLayout(false);
      }
    } catch (error) {
      this.isTokenReady = false;
      this.serviceInit.setEstadoLayout(false);
    }
  }

  private handleAuthenticatedUser() {
    this.serviceInit.setEstadoLayout(true);
    this.loadAndSaveUserInfo();
    this.fetchNotifications();
    this.subscribeToNotifications();
    this.opNotifications();
    this.connectChannel();
  }

  // Método para cargar información del usuario y guardarla en localStorage
  private async loadAndSaveUserInfo(): Promise<void> {
    try {
      await this.cognitoService.hydrateUserContext();
    } catch (error) {
      console.error('Error al cargar información del usuario:', error);
    }
  }

  public async signOut(): Promise<void> {
    try {
      await this.cognitoService.signOut();
      this.serviceInit.setEstadoLayout(false);
      this.isTokenReady = false;
      await this.router.navigateByUrl('/auth', { replaceUrl: true });
    } catch (error) {
      console.error('Error cerrando sesión:', error);
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
    this.estadoLayoutSubscription?.unsubscribe();
    this.notificationsSubscription?.unsubscribe();
    this.disconnectChannel();
  }

  closeDrawer() {
    this.isDrawerVisible = false;
  }

  openDrawer() {
    this.isDrawerVisible = true;
  }

  openSideNav() {
    if (this.mobileQuery.matches) {
      this.isExpanded = true;
      this.snav.opened = true;
    }
  }

  subscribeToNotifications() {
    const subscription =
      this.appBranch === 'prod'
        ? this.notificationsService.OnUpdateExploNotificationsPrd()
        : this.notificationsService.OnUpdateExploNotificationsDev();

    subscription.subscribe({
      next: (data: any) => {
        console.log('Nueva notificación recibida:', data);
        const newNotification =
          this.appBranch === 'prod'
            ? data.onUpdateExploNotificationsPrd
            : data.onUpdateExploNotificationsDev;
        this.notificationsService.addNotification(newNotification);
      },
      error: (error: any) => {
        console.error('Error en la subscribeToNotifications:', error);
      }
    });
  }
  // Método para obtener lstEXplo a las notificaciones de AppSync
  // subscribeToNotifications() {
  //   this.notificationsSubscription = this.notificationsService
  //     .listExploNotificationsDevs()
  //     .subscribe({
  //       next: (data) => {
  //         console.log('Notificaciones:', data);
  //       },
  //       error: (error) => {
  //         console.error('Error al obtener notificaciones:', error);
  //       },
  //     });
  // }
  fetchNotifications() {
    this.notificationsService
      .GetAllNotifications()
      .subscribe((dataNotifications: any) => {
        // Notificaciones obtenidas
        const allNotifications = dataNotifications.getAllNotifications;
        this.notificationsService.setNotifications(allNotifications);
      });
  }

  opNotifications() {
    this.notificationsService.allNotifications.subscribe(
      (dataNotificationsSlice) => {
        if (dataNotificationsSlice?.length > 0) {
          const notificacionesFiltradas = dataNotificationsSlice?.filter(
            (notification: any) =>
              notification.by == 'Sales' || notification.by == 'All'
          );

          this.listaNotificaciones = notificacionesFiltradas;
          this.notificacionesLeidas = notificacionesFiltradas
            .filter(
              (notification: any) =>
                notification.readOp && notification.readOp.trim().length > 0 // Leídas si readOp no está vacío
            )
            .sort((a: any, b: any) => {
              return (
                new Date(b?.createdAt).getTime() -
                new Date(a?.createdAt).getTime()
              );
            });
          this.notificacionesNoLeidas = notificacionesFiltradas
            .filter(
              (notification: any) =>
                !notification.readOp || notification.readOp.trim().length === 0 // No leídas si readOp está vacío
            )
            .sort((a: any, b: any) => {
              return (
                new Date(b?.createdAt).getTime() -
                new Date(a?.createdAt).getTime()
              );
            });
        }
      }
    );
  }

  onTabChange(event: MatTabChangeEvent) {
    const tabIndex = event.index;

    if (tabIndex === 0) {
      this.tab = 'noRead';
    } else if (tabIndex === 1) {
      this.tab = 'read';
    }
  }

  //Eventos
  messages: any[] = [];
  private channel: any;
  private subscription: any = null;
  connected = false;

  async connectChannel() {
    if (this.connected) return;

    try {
      this.channel = await events.connect('/prueba/canal');

      this.subscription = this.channel.subscribe({
        next: (data: any) => {
          // Evento recibido
          console.log('Evento recibido:', data);
          this.messages.unshift(data);
          this.changeDetectorRef.detectChanges();
        },
        error: (err: any) => {
          console.error('Error en suscripción:', err);
        }
      });

      this.connected = true;
      // Conectado al canal
    } catch (err) {
      console.error('Error al conectar al canal:', err);
    }
  }

  disconnectChannel() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
    if (this.channel) {
      this.channel.close();
      this.channel = null;
    }
    this.connected = false;
    // Desconectado del canal
  }
}
